export default "/images/restore-gray.svg";